/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Config_TitleInputs */

const fr_config_title = /** @type {(inputs: Config_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configuration du widget`)
};

const en_config_title = /** @type {(inputs: Config_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Widget configuration`)
};

/**
* | output |
* | --- |
* | "Widget configuration" |
*
* @param {Config_TitleInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const config_title = /** @type {((inputs?: Config_TitleInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Config_TitleInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_config_title(inputs)
	return en_config_title(inputs)
});